import { useState } from "react";
import { useNavigate } from "react-router-dom";

import baseUrl from "../url/baseUrl";

// component tính năng đổi mật khẩu
const ChangePassword = () => {
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const validateForm = () => {
    if (oldPassword.length < 8) {
      setError("Mật khẩu cũ phải dài tối thiểu 8 ký tự.");
      return false;
    }
    if (newPassword.length < 8) {
      setError("Mật khẩu mới phải dài tối thiểu 8 ký tự.");
      return false;
    }
    if (newPassword !== confirmPassword) {
      setError("Mật khẩu mới phải khớp với xác nhận mật khẩu.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    const url = baseUrl + "/change-password";

    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        credentials: "same-origin",
        mode: "cors",

        body: JSON.stringify({
          oldPassword,
          newPassword,
        }),
      });

      if (response.status === 401) {
        throw new Error("Password cũ không chính xác.");
      }
      if (response.status === 404) {
        throw new Error("Không tìm thấy bạn trong server.");
      }
      if (response.status !== 200) {
        throw new Error("Có lỗi xảy ra với server.");
      }

      const data = await response.json();

      alert(data.message);

      navigate("/");
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="d-flex justify-content-center">
      <form style={{ width: "90%", maxWidth: "600px" }} onSubmit={handleSubmit}>
        <h4 className="text-success text-uppercase text-center mt-4">
          Đổi mật khẩu
        </h4>
        <p className="text-danger text-center">{error}</p>
        <div className="d-flex flex-column mb-4">
          <label htmlFor="oldPass" className="text-muted fst-italic">
            Mật khẩu cũ
          </label>
          <input
            className="form-control text-start"
            id="oldPass"
            type="password"
            value={oldPassword}
            onChange={(e) => setOldPassword(e.target.value)}
            required
          />
        </div>

        <div className="d-flex flex-column mb-2">
          <label htmlFor="newPass" className="text-muted fst-italic">
            Mật khẩu mới
          </label>
          <input
            className="form-control text-start"
            id="newPass"
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>

        <div className="d-flex flex-column mb-3">
          <label htmlFor="confirmPass" className="text-muted fst-italic">
            Xác nhận mật khẩu mới
          </label>
          <input
            className="form-control text-start"
            id="confirmPass"
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <div>
          <button className="btn btn-outline-primary mb-3 " type="submit">
            Xác nhận
          </button>
        </div>
      </form>
    </div>
  );
};

export default ChangePassword;
